import React, { useState, useEffect, useRef, useCallback } from 'react';
import RedeemCategory from './RedeemCategory';
import './App.css';

export default function App() {
  const ACTIVE_SET_STORAGE_KEY = 'aura_active_set';
  const [user, setUser] = useState(null);
  const [currency, setCurrency] = useState(null);

  // 🔄 Fetch username from /api/user instead of window.CURRENT_USER
  useEffect(() => {
    async function fetchUser() {
      try {
        const res = await fetch('/api/user');
        const data = await res.json();
        setUser(data);

        if (data && data.displayName) {
          // Fetch currency once logged in
          fetch('/api/currency')
            .then(res => res.ok ? res.json() : Promise.reject(res))
            .then(data => setCurrency(data.currency))
            .catch(err => console.error("Currency fetch failed:", err));
        }
      } catch (err) {
        console.error('Failed to fetch user info:', err);
      }
    }
    fetchUser();
  }, []);

	const refreshCurrency = useCallback(() => {
	  if (!user || !user.displayName) return;

	  fetch('/api/currency')
		.then(res => res.ok ? res.json() : Promise.reject(res))
		.then(data => setCurrency(data.currency))
		.catch(err => console.error("Currency refresh failed:", err));
	}, [user]); // depends on user only

  const [activeSet, setActiveSet] = useState(() => {
    try {
      const url = new URL(window.location.href);
      const fromQuery = url.searchParams.get('set');
      if (fromQuery === 'alni' || fromQuery === 'teemo') {
        return fromQuery;
      }
      const saved = window.localStorage.getItem(ACTIVE_SET_STORAGE_KEY);
      return saved === 'teemo' ? 'teemo' : 'alni';
    } catch {
      return 'alni';
    }
  });
  const [animate, setAnimate] = useState(false);
  const [buttonWidth, setButtonWidth] = useState(null);
  
	const alniRef = useRef(null);
	const teemoRef = useRef(null);

	useEffect(() => {
	  if (alniRef.current && teemoRef.current) {
		const alniWidth = alniRef.current.offsetWidth;
		const teemoWidth = teemoRef.current.offsetWidth;
		const maxWidth = Math.max(alniWidth, teemoWidth);
		setButtonWidth(maxWidth);
	  }
	}, [user]);

  useEffect(() => {
    try {
      window.localStorage.setItem(ACTIVE_SET_STORAGE_KEY, activeSet);
    } catch (err) {
      console.warn('Failed to persist active tab:', err);
    }
  }, [activeSet, ACTIVE_SET_STORAGE_KEY]);

  useEffect(() => {
    try {
      const url = new URL(window.location.href);
      if (url.searchParams.has('set')) {
        url.searchParams.delete('set');
        const nextSearch = url.searchParams.toString();
        const cleanUrl = `${url.pathname}${nextSearch ? `?${nextSearch}` : ''}${url.hash}`;
        window.history.replaceState({}, '', cleanUrl);
      }
    } catch (err) {
      console.warn('Failed to clean tab query param:', err);
    }
  }, []);
  
  const cost = "10 Points";
  const boobcost = "1000 Points";
  const [toast, setToast] = useState(null);
  
const handleLogout = async () => {
  try {
    console.log('🟢 Logout button clicked');

    const res = await fetch(`${window.location.origin}/auth/logout`, {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      credentials: 'include',
    });

    const text = await res.text();
    console.log('🧾 Logout raw response:', text);

    let data;
    try {
      data = JSON.parse(text);
    } catch (err) {
      console.warn('⚠️ Logout response not JSON, assuming success');
      data = { success: true };
    }

    if (!res.ok || !data.success) throw new Error(data.error || 'Logout failed');

    setUser(null);
    setCurrency(null);
    setToast(null);
    localStorage.clear();
    sessionStorage.clear();

    console.log('✅ Logged out successfully, reloading app…');
    window.location.href = '/app';
  } catch (err) {
    console.error('❌ Logout failed:', err);
  }
};

  function handleRedeemToast(label) {
    setToast(`Sent redeem: ${label}!`);
    setTimeout(() => refreshCurrency(), 1000);
    setTimeout(() => setToast(null), 2000);
  }

  // --- Alni's Redeems ---
  const alniCategories = [
    {
      title: "Effects",
      cost,
	  visibility: "both",
      items: [
        { label: "Rainbow", href: "/wh/rainbow" },
        { label: "Censor", href: "/wh/censor" },
        { label: "CarCario", href: "/wh/carcario" },
        { label: "Aura Sphere", href: "/wh/aurasphere" },
        { label: "Goo", href: "/wh/goo" },
      ],
    },
    {
      title: "Interaction",
      cost,
	  visibility: "both",
      items: [
        { label: "Headpats", href: "/wh/headpats" },
        { label: "Hug", href: "/wh/hug" },
        { label: "Hydrate", href: "/wh/hydrate" },
        { label: "Confetti", href: "/wh/confetti" },
        { label: "Stab", href: "/wh/stab" },
        { label: "Speen", href: "/wh/speen" },
        { label: "10 Push-ups", href: "/wh/pushup" },
        { label: "Embiggen", href: "/wh/embiggen" },
      ],
    },
    {
      title: "Dances / Poses",
      cost,
	  visibility: "both",
      items: [
        { label: "Coffin Dance", href: "/wh/coffindance" },
        { label: "Chicken Attack", href: "/wh/chickenattack" },
        { label: "Sit", href: "/wh/sit" },
      ],
    },
    {
      title: "Mega Form Colors",
      cost,
	  visibility: "alni",
      items: [
        { label: "blueberry", href: "/wh/blueberry" },
        { label: "pumpkario", href: "/wh/pumpkario" },
        { label: "red", href: "/wh/red" },
        { label: "minty", href: "/wh/minty" },
        { label: "quex", href: "/wh/quex" },
        { label: "steven", href: "/wh/steven" },
      ],
    },
    {
      title: "Wolf Teemo Colors",
      cost,
	  visibility: "teemo",
      items: [
        { label: "teemo", href: "/wh/teemo" },
        { label: "beemo", href: "/wh/beemo" },
        { label: "rainbeemo", href: "/wh/rainbeemo" },
      ],
    },
    {
      title: "Base Colors",
      cost,
	  visibility: "both",
      items: [
        { label: "blueberry", href: "/wh/blueberry" },
        { label: "cottoncandy", href: "/wh/cottoncandy" },
        { label: "pumpkario", href: "/wh/pumpkario" },
        { label: "blue", href: "/wh/blue" },
        { label: "red", href: "/wh/red" },
        { label: "shiny", href: "/wh/shiny" },
        { label: "pink", href: "/wh/pink" },
      ],
    },
    {
      title: "OBS Filters",
      cost,
	  visibility: "both",
      items: [
        { label: "green", href: "/wh/green" },
        { label: "orange", href: "/wh/orange" },
        { label: "purple", href: "/wh/purple" },
        { label: "magenta", href: "/wh/magenta" },
        { label: "neon", href: "/wh/neon" },
        { label: "black", href: "/wh/black" },
        { label: "ghost", href: "/wh/ghost" },
		{ label: "Reset Filters", href: "/wh/obsreset" },
      ],
    },
    {
      title: "Streamer Themes",
      cost,
	  visibility: "both",
      items: [
        { label: "Teemo", href: "/wh/teemo" },
        { label: "Gabe", href: "/wh/gabe" },
        { label: "Aurora", href: "/wh/aurora" },
        { label: "Astral", href: "/wh/astral" },
        { label: "Sharp", href: "/wh/sharp" },
        { label: "Velneffi", href: "/wh/velcario" },
        { label: "Poof", href: "/wh/poof" },
        { label: "rumply", href: "/wh/rumply" },
        { label: "steven", href: "/wh/steven" },
        { label: "myrkur", href: "/wh/myrkur" },
        { label: "quex", href: "/wh/quex" },
        { label: "leroy", href: "/wh/leroy" },
        { label: "jinx", href: "/wh/jinx" },
        { label: "sneako", href: "/wh/sneako" },
        { label: "robyn", href: "/wh/robyn" },
      ],
    },
    {
      title: "Food",
      cost,
	  visibility: "both",
      items: [
        { label: "Cookie", href: "/wh/cookie" },
        { label: "Apple", href: "/wh/apple" },
        { label: "Banana", href: "/wh/banana" },
        { label: "Sushi", href: "/wh/sushi" },
      ],
    },
    {
      title: "Outfits",
      cost,
	  visibility: "both",
      items: [
        { label: "Collar", href: "/wh/collar" },
        { label: "Jacket", href: "/wh/jacket" },
        { label: "Hat & Cape", href: "/wh/hatandcape" },
        { label: "Cafe Mix", href: "/wh/cafemix" },
        { label: "Concert", href: "/wh/concert" },
        { label: "Martial Arts", href: "/wh/martial" },
        { label: "Wanderer", href: "/wh/wanderer" },
        { label: "Aristocrat", href: "/wh/aristocrat" },
        { label: "Bat Wings", href: "/wh/batwings" },
      ],
    },
    {
      title: "Mega Outfits",
      cost,
	  visibility: "alni",
      items: [
        { label: "Collar", href: "/wh/collar" },
        { label: "Bat Wings", href: "/wh/batwings" },
        { label: "Hoodie", href: "/wh/hoodie" },
        { label: "Arm Warmers", href: "/wh/warmers" },
        { label: "Glasses", href: "/wh/glasses" },
      ],
    },
    {
      title: "Boobs",
      cost: boobcost,
	  visibility: "alni",
      items: [{ label: "Boobs", href: "/wh/boobs" }],
    },
    {
      title: "Throwables",
      cost,
	  visibility: "both",
      items: [
        { label: "Slipper", href: "/wh/slipper" },
        { label: "Banana", href: "/wh/banana-t" },
        { label: "Duck", href: "/wh/duck" },
        { label: "Bone", href: "/wh/bone" },
        { label: "Bucket", href: "/wh/bucket" },
        { label: "Box", href: "/wh/box" },
        { label: "Pie", href: "/wh/pie" },
        { label: "Sombrero", href: "/wh/sombrero" },
        { label: "Anvil", href: "/wh/anvil" },
        { label: "Bell", href: "/wh/bell" },
        { label: "Pokeball", href: "/wh/pokeball" },
        { label: "Quickball", href: "/wh/quickball" },
      ],
    },
    {
      title: "Hats",
      cost,
	  visibility: "both",
      items: [
        { label: "News Boy", href: "/wh/newsboy" },
        { label: "Steampunk v1", href: "/wh/steampunk1" },
        { label: "Steampunk v2", href: "/wh/steampunk2" },
        { label: "Witch Hat", href: "/wh/witchhat" },
        { label: "Boater Hat", href: "/wh/boater" },
        { label: "Capelin Hat", href: "/wh/capelinhat" },
        { label: "Goggles", href: "/wh/goggles" },
        { label: "Goggles-Neck", href: "/wh/goggles-neck" },
      ],
    },
    {
      title: "Resets",
      cost,
	  visibility: "both",
      items: [
        { label: "Outfit Reset", href: "/wh/resetoutfits" },
        { label: "Color Reset", href: "/wh/blueberry" },
        { label: "Pose Reset", href: "/wh/fixshit" },
      ],
    },
    {
      title: "Misc",
      cost,
	  visibility: "both",
      items: [
        { label: "Jail", href: "/wh/jail" },
        { label: "Bonk", href: "/wh/bonk" },
        { label: "TNT", href: "/wh/tnt" },
        { label: "Outfitocalypse", href: "/wh/ohno" },
        { label: "UwU", href: "/wh/uwu" },
      ],
    },
  ];

function getCategories(mode, isMega, isWolf = true) {
  return alniCategories
    .filter(cat => {
      const vis = cat.visibility ?? "both";
      const visibleForMode = vis === "both" || vis === mode;

      // ✨ Hide or show things based on Alni's Mega state
      const hideIfMega =
        mode === "alni" &&
        isMega &&
        (cat.title === "Base Colors" || cat.title === "Outfits" || cat.title === "Streamer Themes");

      const hideIfNotMega =
        mode === "alni" &&
        !isMega &&
        (cat.title === "Mega Form Colors" || cat.title === "Mega Outfits" || cat.title === "Boobs");

      // 🐺 Hide Base Colors when Teemo is in wolf mode
      const hideIfWolf =
        mode === "teemo" &&
        isWolf &&
        cat.title === "Base Colors" || cat.title === "Streamer Themes" || cat.title === "Outfits";

      return visibleForMode && !hideIfMega && !hideIfNotMega && !hideIfWolf;
    })
    .map(cat => ({
      ...cat,
      items: cat.items.map(item => ({
        ...item,
        href: item.href.replace('/wh/', mode === "teemo" ? '/tt/' : '/wh/'),
      })),
    }));
}
	
	const [megaState, setMegaState] = useState(0);

	useEffect(() => {
	  async function fetchMegaState() {
		try {
		  const res = await fetch('/api/getMegaState');
		  const data = await res.json();
		  console.log('fetchMegaState:', data);
		  setMegaState(data.megaState); // 1 = Mega
		} catch (err) {
		  console.error('Failed to fetch mega state:', err);
		}
	  }
	  fetchMegaState();
	}, []);

useEffect(() => {
  let intervalId;

  async function fetchMegaState() {
    try {
      const res = await fetch('/api/getMegaState');
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
	  
      const data = await res.json();
      console.log('useEffect fetchMegaState:', data.megaState);
      // Only update if changed
      setMegaState(prev => {
        if (prev !== data.megaState) {
		  setTimeout(() => refreshCurrency(), 1000);
          console.log('🔄 Mega state changed to:', data.megaState);
        }
        return data.megaState;
      });
    } catch (err) {
      console.error('❌ Failed to fetch mega state:', err);
    }
  }

  // Fetch immediately, then periodically
  fetchMegaState();
  intervalId = setInterval(fetchMegaState, 1000); // check every 3 seconds

  // Cleanup
  return () => clearInterval(intervalId);
}, [refreshCurrency]);

	const categories = getCategories(activeSet, megaState === 1);

  useEffect(() => {
    const nav = document.querySelector('.navbar.w-nav');
    if (nav) {
      const navHeight = nav.offsetHeight;
      document.documentElement.style.setProperty('--nav-height', `${navHeight}px`);
    }
  }, []);

  useEffect(() => {
    setAnimate(true);
    const timer = setTimeout(() => setAnimate(false), 600);
    return () => clearTimeout(timer);
  }, [activeSet]);
  
useEffect(() => {
  let attempts = 0;
  const maxAttempts = 30;

  const reinitWebflow = () => {
    if (!window.Webflow || typeof window.Webflow.require !== 'function') {
      return false;
    }

    try {
      window.Webflow.destroy?.();
      window.Webflow.ready?.();
      window.Webflow.require('ix2').init?.();
      return true;
    } catch (err) {
      console.error('❌ Failed to reinitialize Webflow:', err);
      return false;
    }
  };

  if (reinitWebflow()) {
    return undefined;
  }

  const timer = window.setInterval(() => {
    attempts += 1;
    if (reinitWebflow() || attempts >= maxAttempts) {
      window.clearInterval(timer);
    }
  }, 100);

  return () => window.clearInterval(timer);
}, []);

const [cooldown, setCooldown] = useState(0);

// ⏳ countdown effect
useEffect(() => {
  if (cooldown <= 0) return;
  const timer = setInterval(() => {
    setCooldown(prev => (prev > 0 ? prev - 1 : 0));
  }, 1000);
  return () => clearInterval(timer);
}, [cooldown]);

return (
  <div className="page-shell">
    {/* --- Webflow Navbar --- */}
    <div
      data-collapse="medium"
      data-animation="default"
      data-duration="400"
      data-easing="ease"
      data-easing2="ease"
      role="banner"
      className="navbar w-nav"
    >
      <div className="w-container">
        <a href="/index.html" className="brand-wrapper w-nav-brand">
          <div className="logo-text">Alni and Teemo's Aura Alcove</div>
        </a>
        <nav role="navigation" className="nav-menu w-clearfix w-nav-menu">
          <a href="/index.html" className="nav-link w-nav-link">Home</a>
          <a
            href="/app?set=alni"
            onClick={(e) => { e.preventDefault(); setActiveSet("alni"); }}
            className={`nav-link w-nav-link ${activeSet === "alni" ? "is-current" : ""}`}
          >
            Alnitak's Redeems
          </a>
          <a
            href="/app?set=teemo"
            onClick={(e) => { e.preventDefault(); setActiveSet("teemo"); }}
            className={`nav-link w-nav-link ${activeSet === "teemo" ? "is-current" : ""}`}
          >
            Teemo's Redeems
          </a>
          <a href="/artistsalley.html" className="nav-link w-nav-link">Artists Alley</a>
          <a href="/credits.html" className="nav-link w-nav-link">Credits</a>
          <a href="/about-contact.html" className="nav-link w-nav-link">About &amp; Contact</a>
          {user?.displayName ? (
            <a href="/auth/logout" className="nav-link right w-nav-link logged-in">
              {user.displayName}
            </a>
          ) : (
            <a href="/auth/twitch" className="nav-link right w-nav-link">
              Log in with Twitch!
            </a>
          )}
        </nav>
        <div className="menu-button w-nav-button">
          <div className="w-icon-nav-menu"></div>
        </div>
      </div>
    </div>

    {/* --- Existing topbar starts here --- */}
    <header className="topbar">
        <div className="topbar-inner">
          <div className="branding">
			  <a
				href="https://aura-alcove.com/index.html"
				className="site-title underlined-link"
			  >
				Alni &amp; Teemo's Aura Alcove
			  </a>
			  <div className="subtitle">
				{activeSet === 'alni' ? "Alnitak's Redeems" : "Teemo's Redeems"}
			  </div>
			</div>

          <div className="toggle-and-stats">
			<div className="toggle-container">
				<button
				  ref={alniRef}
				  className={activeSet === 'alni' ? 'active' : ''}
				  style={{ width: buttonWidth ? `${buttonWidth}px` : 'auto' }}
				  onClick={() => {
					if (activeSet !== 'alni') {
					  setAnimate(true);
					  setTimeout(() => {
						setActiveSet('alni');
					  }, 400);
					}
				  }}
				>
				  Alni
				</button>

				<button
				  ref={teemoRef}
				  className={activeSet === 'teemo' ? 'active' : ''}
				  style={{ width: buttonWidth ? `${buttonWidth}px` : 'auto' }}
				  onClick={() => {
					if (activeSet !== 'teemo') {
					  setAnimate(true);
					  setTimeout(() => {
						setActiveSet('teemo');
					  }, 400);
					}
				  }}
				>
				  Teemo
				</button>
			</div>

            {user?.displayName && (
              <div className="session-stats">
                <div className="session-line">
                  <span className="session-user">{user.displayName}</span>
                  {currency !== null && (
                    <>
                      <span className="session-sep">•</span>
                      <span className="session-currency">
                        {currency.toLocaleString()} Auracite
                      </span>
                    </>
                  )}
                </div>
              </div>
            )}
          </div>

          <div className="actions">
            <a className="random-button" href={activeSet === 'alni' ? '/wh/random' : '/tt/random'}>
              🎲 Random Color
            </a>

            {user?.displayName ? (
              <div className="login-info-inline">
				<div className="login-button logged-in-badge" onClick={handleLogout} style={{ cursor: 'pointer' }}>
				  Logout
				</div>
              </div>
            ) : (
              <a className="login-button" href="/auth/twitch">
                Log in with Twitch
              </a>
            )}
          </div>
        </div>
      </header>

      <main className="content-area">
        {toast && <div className="toast-pop">{toast}</div>}
		
		{activeSet === "alni" && (
		  <div className={`mega-indicator ${animate ? 'fade' : ''}`}>
			<button
			  className={`mega-button ${megaState === 1 ? 'active' : 'inactive'}`}
			  onClick={async () => {
				if (cooldown > 0) return; // ⛔ ignore clicks during cooldown
				if (!user || !user.displayName) {
				  window.location.href = "/auth/twitch";
				  return;
				}

				try {
				  const url = megaState === 1 ? '/wh/unmega' : '/wh/mega';
				  console.log(`⚙️ Sending ${url}...`);
				  const res = await fetch(url);
				  if (!res.ok) throw new Error(`HTTP ${res.status}`);

				  // Force refresh of Mega state
				  const stateRes = await fetch('/api/getMegaState');
				  const stateData = await stateRes.json();
				  setMegaState(stateData.megaState);

				  // Start cooldown timer (10s)
				  setCooldown(7);
				} catch (err) {
				  console.error('❌ Failed to toggle Mega state:', err);
				}
			  }}
			  disabled={cooldown > 0}
			>
			  {cooldown > 0
				? `Cooldown: ${cooldown}s`
				: megaState === 1
				  ? 'Mega Form Active — Click to Revert'
				  : 'Base Form — Click to Mega Evolve'}
			</button>
		  </div>
		)}

		<div className={`categories-grid ${animate ? 'fade-enter' : ''}`}>
		  {categories.map(cat => (
			<RedeemCategory
			  key={cat.title}
			  title={cat.title}
			  cost={cat.cost}
			  items={cat.items}
			  onRedeem={handleRedeemToast}
			/>
		  ))}
		</div>
      </main>

      <footer className="footer-bar">
        <div className="footer-inner">
          <div className="footer-left">
            <div className="footer-heading">alni and teemo's aura alcove</div>
            <nav className="footer-links">
              <a href="/index.html">Home</a>
              <a href="/alnitaksredeems.html">Alnitak's Redeems</a>
              <a href="/teemosredeems.html">Teemo's Redeems</a>
              <a href="/artistsalley.html">Artists Alley</a>
              <a href="/credits.html">Credits</a>
              <a href="/about-contact.html">About &amp; Contact</a>
            </nav>
          </div>

          <div className="footer-cta">
            <div className="footer-cta-text">
              {activeSet === 'alni'
                ? "Check out Teemo's redeems! He's my boyfriend, and he's pretty cool too :P"
                : "Check out Alnitak's redeems! He’s the cutest Lucario, go look already!"}
            </div>
            <button
              className="teemo-button"
              onClick={() => setActiveSet(activeSet === 'alni' ? 'teemo' : 'alni')}
            >
              {activeSet === 'alni' ? "Teemo's Redeems ❯" : "Alni's Redeems ❯"}
            </button>
          </div>
        </div>
      </footer>
    </div>
  );
}
